import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * En-tête des pages intérieures : fil d'Ariane, titre unique de la page,
 * chapô et actions. `chemin` liste les pages parentes, [libellé, adresse].
 */
export const EnTetePage = ({ chemin, titre, chapo, children }) => (
  <section className="bg-bg2 px-6 pb-10 pt-28 sm:px-10 lg:px-12 lg:pb-14 lg:pt-36">
    <div className="shell">
      <nav aria-label="Fil d'Ariane">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-vt-controle font-semibold text-t2">
          {chemin.map(([libelle, adresse]) => (
            <li key={adresse} className="flex items-center gap-2">
              <Link to={adresse} className="text-brand">
                {libelle}
              </Link>
              <ChevronRight className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" />
            </li>
          ))}
          <li aria-current="page">{titre}</li>
        </ol>
      </nav>

      <h1 className="mt-6 max-w-[22ch] font-display text-vt-hero font-extrabold leading-[1.1] tracking-[-0.03em] text-brand">
        {titre}
      </h1>
      <p className="lede mt-6 max-w-[760px]">{chapo}</p>

      {children && <div className="mt-9 flex flex-wrap gap-4">{children}</div>}
    </div>
  </section>
);
